import { render } from "./JigsawQuestion.vue?vue&type=template&id=1a3c680c&scoped=true&ts=true"
import script from "./JigsawQuestion.vue?vue&type=script&lang=ts"
export * from "./JigsawQuestion.vue?vue&type=script&lang=ts"

import "./JigsawQuestion.vue?vue&type=style&index=0&id=1a3c680c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3c680c"]])

export default __exports__